import { render, staticRenderFns } from "./Perguntas.vue?vue&type=template&id=d20c140e&scoped=true&"
import script from "./Perguntas.vue?vue&type=script&lang=js&"
export * from "./Perguntas.vue?vue&type=script&lang=js&"
import style0 from "./Perguntas.vue?vue&type=style&index=0&id=d20c140e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20c140e",
  null
  
)

export default component.exports